// /admin -> the first Platform settings tab (M11, S12).
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/$tab', params: { tab: 'security-groups' } });
  },
});
